import { RouteObject } from "react-router-dom";
import AppLayout from "./shared/AppLayout";
import ClientMinimalHeaderLayout from "./shared/ClientMinimalHeaderLayout";
import { Home } from "./features/Home";
import { NotificationProvider } from "./features/Notifications";
import CEONote from "./features/ceonote";

export const routes: RouteObject[] = [
  {
    path: "/",
    async lazy() {
      const { LandingPage } = await import("./features/LandingPage");
      return { element: <LandingPage /> };
    }
  },
  {
    path: "profile-setup",
    async lazy() {
      const { ProfileSetup } = await import("./features/ProfileSetup");
      return { element: <ProfileSetup /> };
    }
  },
  {
    path: "contact-support",
    async lazy() {
      const { ContactSupport } = await import("./features/ContactSupport");
      return { element: <ContactSupport /> };
    }
  },
  {
    path: "/:id",
    async lazy() {
      const { LandingArticleDetails } = await import("./features/LandingPage");
      return { element: <LandingArticleDetails /> };
    }
  },
  
  {
    element: (
      <NotificationProvider>
        <AppLayout />
      </NotificationProvider>
    ),
    children: [
      {
        path: "home",
        element: <Home />
      },
      {
        path: "MessageDetails",
        async lazy() {
          const { MessageDetails } = await import(
            "./features/Home/"
          );
          return { element: <MessageDetails /> };
        }
      },
      {
        path: "alumini-directory",
        async lazy() {
          const { AluminiDirectory } = await import(
            "./features/AluminiDirectory"
          );
          return { element: <AluminiDirectory /> };
        }
      },
      {
        path: "alumini-directory/:employeeId",
        async lazy() {
          const { ProfileView } = await import(
            "./features/AluminiDirectory"
          );
          return { element: <ProfileView /> };
        }
      },
      {
        path: "profile",
        async lazy() {
          const { ProfileView } = await import(
            "./features/AluminiDirectory"
          );
          return { element: <ProfileView /> };
        }
      },
      {
        path: "insights",
        async lazy() {
          const { Thoughtware } = await import(
            "./features/Thoughtware"
          );
          return { element: <Thoughtware /> };
        }
      },
      {
        path: "insights-detail/:postId",
        async lazy() {
          const { ThoughtwareDetails } = await import(
            "./features/Thoughtware"
          );
          return { element: <ThoughtwareDetails /> };
        }
      },
      {
        path: "terms-of-use",
        async lazy() {
          const TermsOfUse = (await import(
            "./features/Thoughtware/Instructions/TermsOfUse"
          )).default;
          return { element: <TermsOfUse /> };
        }
      },
      {
        path: "privacy-policy",
        async lazy() {
          const PrivacyPolicy = (await import(
            "./features/Thoughtware/Instructions/PrivacyPolicy"
          )).default;
          return { element: <PrivacyPolicy /> };
        }
      },
      {
        path: "disclaimer",
        async lazy() {
          const Disclaimer = (await import(
            "./features/Thoughtware/Instructions/Disclaimer"
          )).default;
          return { element: <Disclaimer /> };
        }
      },
      {
        path: "events",
        async lazy() {
          const { Events } = await import("./features/Events");
          return { element: <Events /> };
        }
      },
      {
        path: "events/:id",
        async lazy() {
          const EventsDetails = (await import(
            "./features/Events/EventsDetails"
          )).default;
          return { element: <EventsDetails /> };
        }
      },
      {
        path: "helpdesk",
        async lazy() {
          const { HelpDesk } = await import(
            "./features/HelpDesk"
          );
          return { element: <HelpDesk /> };
        }
      },
      {
        path: "conversations",
        async lazy() {
          const { Conversation } = await import(
            "./features/Conversation"
          );
          return { element: <Conversation /> };
        }
      },
      {
        path: "notifications",
        async lazy() {
          const { Notifications } = await import(
            "./features/Notifications"
          );
          return { element: <Notifications /> };
        }
      },
      {
        path:'ceo-notes',
        element: <CEONote />
      },
      {
        path: "marketplace-jobs",
        async lazy() {
          const { JobMarketplace } = await import(
            "./features/JobMarketplace"
          );
          return { element: <JobMarketplace /> };
        }
      }, 
      {
        path: "admin/marketplaceJobs",
        async lazy() {
          const { MarketplaceJobs } = await import(
            "./features/Admin/MarketplaceJobs"
          );
          return { element: <MarketplaceJobs /> };
        }
      }, 
      {
        path: "admin/marketplaceJobs/ViewJobDetails",
        async lazy() {
          const { ViewJobDetails } = await import(
            "./features/Admin/MarketplaceJobs"
          );
          return { element: <ViewJobDetails /> };
        }
      }, 
      
      {
        path: "admin/marketplaceJobs/ApplicantsList",
        async lazy() {
          const { ApplicantsList } = await import(
            "./features/Admin/MarketplaceJobs"
          );
          return { element: <ApplicantsList /> };
        }
      }, 
      {
        path: "admin/marketplaceJobs/PastApplicantsList",
        async lazy() {
          const { PastApplicantsList } = await import(
            "./features/Admin/MarketplaceJobs"
          );
          return { element: <PastApplicantsList /> };
        }
      }, 
      {
        path: "admin/impersonate",
        async lazy() {
          const { ImpersonateUser } = await import(
            "./features/Admin"
          );
          return { element: <ImpersonateUser /> };
        }
      },
      {
        path: "admin/alumniDirectory",
        async lazy() {
          const { AlumniDirectory } = await import(
            "./features/Admin/alumniDirectory"
          );
          return { element: <AlumniDirectory /> };
        }
      },
      {
        path: "admin/ProfileView",
        async lazy() {
          const { ProfileView } = await import(
            "./features/Admin/alumniDirectory"
          );
          return { element: <ProfileView /> };
        }
      }, 
      {
        path: "admin/Conversation",
        async lazy() {
          const { Conversation } = await import(
            "./features/Admin/Conversation"
          );
          return { element: <Conversation /> };
        }
      }, 
      {
        path: "marketplace-jobs/:jobTitle",
        async lazy() {
          const { JobDetail } = await import(
            "./features/JobMarketplace"
          );
          return { element: <JobDetail /> };
        }
      },
      {
        path: "dashboard",
        async lazy() {
          const { Dashboard } = await import(
            "./features/Admin/Dashboard"
          );
          return { element: <Dashboard /> };
        }
      },
       {
        path: "dashboard/view-request/:employeeId",
        async lazy() {
          const { ViewRequest } = await import(
            "./features/Admin/Dashboard"
          );
          return { element: <ViewRequest /> };
        }
      },
      {
        path: "dashboard/acknowledge/:requestId",
        async lazy() {
          const { Acknowledge } = await import(
            "./features/Admin/Dashboard"
          );
          return { element: <Acknowledge /> };
        }
      },
      {
        path: "admin/content-management",
        async lazy() {
          const { ContentManagement } = await import(
            "./features/Admin/ContentManagement"
          );
          return { element: <ContentManagement /> };
        }
      },
      {
        path: "admin/new-article",
        async lazy() {
          const { NewArticle } = await import(
            "./features/Admin/ContentManagement"
          );
          return { element: <NewArticle /> };
        }
      },
    ]
  },
  {
    element: <ClientMinimalHeaderLayout />,
    children: [
      {
        path: "marketplace-jobs/post-job",
        async lazy() {
          const { PostJob } = await import("./features/JobMarketplace");
          return { element: <PostJob /> };
        }
      }
    ]
  }
];